Em.Handlebars.helper 't2', (context, word) ->
  return '' unless word && context
  Em.I18n.t "#{context}.#{word.toLowerCase()}"
